var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal',{attrs:{"show":_vm.show},on:{"close":_vm.close}},[_c('h1',[_vm._v("Modal Elements")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }